import { CanActivateFn } from '@angular/router';
import { of } from 'rxjs';
import { inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { decodeJwt } from '@shared/utils/jwt.util';
import { AuthSessionService } from '@shared/services/auth-session/auth-session.service';

export const authGuard: CanActivateFn = () => {
	const cookieService = inject(CookieService);
	const router = inject(Router);
	const authSessionService = inject(AuthSessionService);

	if (authSessionService.isLoggedOutManually()) {
		router.navigate(['/login-nuevo']);
		return of(false);
	}

	const authData = cookieService.get('authData');
	let token: string | null = null;

	if (authData) {
		try {
			token = JSON.parse(authData)?.access_token ?? null;
		} catch {
			token = null;
		}
	}

	if (token) {
		try {
			const tokenPayload = decodeJwt(token);
			if (!tokenPayload) {
				cookieService.delete('authData', '/');
				router.navigate(['/login-nuevo']);
				return of(false);
			}

			const expirationTime = (tokenPayload?.['exp'] ?? 0) * 1000;
			const currentTime = Date.now();

			if (expirationTime > currentTime) {
				return of(true);
			}

			cookieService.delete('authData', '/');
			router.navigate(['/login-nuevo']);
			return of(false);
		} catch (error) {
			console.error('❌ Error al decodificar el token:', error);
			cookieService.delete('authData', '/');
			router.navigate(['/login-nuevo']);
			return of(false);
		}
	} else {
		router.navigate(['/login-nuevo']);
		return of(false);
	}
};
